<template>
	<Chat
		:show="showModal"
		@close="handleCloseModal"
		@sendMessage="handleSendMessage"
		@typing="handleTyping"
		:isTyping="typing"
		:messages="messages"
		:loading="loading"
		id="chat_modal"
	/>
</template>

<script>
	import Chat from "../components/Chat/Chat.vue";
	import {io} from "socket.io-client";
	import axios from "axios";
	export default {
		components: {Chat},
		data() {
			return {
				showModal: false,
				socketInstance: io(process.env.VUE_APP_SOCKET_API),
				userData: "",
				message: "",
				messages: [],
				typing: false,
				loading: false,
				timer: null,
			};
		},
		methods: {
			async socket() {
				const axios = require("axios");
				this.socketInstance.on("connect", async () => {
					console.log("connected");
					this.socketInstance.emit("new_user", {
						socket_id: this.socketInstance.id,
						ip: this.userData.ip,
						url: window.location.href,
						browser: this.getBrowser(),
						platform: navigator.platform,
						date: new Date(),
						referer: document.referrer,
						locale: navigator.language,
						isModalOpen: this.showModal,
						moreInfo: this.userData,
					});
				});
				this.socketInstance.on("toggleModal", ({user, status}) => {
					if (this.socketInstance.id == user.socket_id) {
						this.showModal = status;
					}
				});
				this.socketInstance.on("disconnect", () => {
					console.log("disconnected");
				});
				this.socketInstance.on("new_message", ({message, socket_id}) => {
					if (this.socketInstance.id == socket_id) {
						this.messages.push(message);
					}
					this.scrollChatDiv();
				});
				this.socketInstance.on("typing", ({isTyping, userData}) => {
					if (
						this.socketInstance.id == userData.socket_id &&
						userData.user_type == "admin"
					) {
						this.typing = isTyping;
					}
				});
			},
			async handleCloseModal() {
				this.showModal = false;
				this.socketInstance.emit("toggleModal", {user: this.userData, status: false});
			},
			async handleTyping(message) {
				if (this.timer) clearTimeout(this.timer);
				let userData = {
					...this.userData,
					socket_id: this.socketInstance.id,
					user_type: "customer",
				};
				this.socketInstance.emit("typing", {
					isTyping: true,
					userData,
				});
				this.timer = setTimeout(() => {
					this.socketInstance.emit("typing", {
						isTyping: false,
						userData,
					});
				}, 1000);
			},
			async handleSendMessage(message) {
				const postParams = {
					ip: this.userData.ip,
					message: message,
					user_type: "customer",
				};
				const {data} = await axios.post(
					process.env.VUE_APP_SOCKET_API + "/api/message",
					postParams
				);
				// this.messages.push(data.message);
				this.scrollChatDiv();
				this.socketInstance.emit("new_message", {
					message: data.message,
					socket_id: this.socketInstance.id,
				});
			},

			scrollChatDiv() {
				const chatDiv = document.getElementById("chat_div");
				setTimeout(() => {
					chatDiv.scrollTop = chatDiv.scrollHeight;
				}, 100);
			},

			getBrowser() {
				var ua = navigator.userAgent,
					tem,
					M =
						ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
				if (/trident/i.test(M[1])) {
					tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
					return "IE " + (tem[1] || "");
				}
				if (M[1] === "Chrome") {
					tem = ua.match(/\bOPR\/(\d+)/);
					if (tem != null) {
						return "Opera " + tem[1];
					}
				}
				M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
				if ((tem = ua.match(/version\/(\d+)/i)) != null) {
					M.splice(1, 1, tem[1]);
				}
				return M.join(" ");
			},
			async getUserInfo() {
				return await axios.get("https://ipapi.co/json/");
			},
			async fetchMessages() {
				this.loading = true;
				try {
					const {data} = await axios.post(
						process.env.VUE_APP_SOCKET_API + "/api/messages",
						{
							ip: this.userData.ip,
						}
					);
					this.messages = data.messages;
					this.loading = false;
					this.scrollChatDiv();
				} catch (error) {
					console.log(error);
					this.loading = false;
				}
			},
		},
		mounted() {
			this.getUserInfo().then((res) => {
				this.userData = res.data;
				this.socket();
			});
		},
		watch: {
			showModal(val) {
				if (val) {
					this.messages = [];
					this.fetchMessages();
				}
			},
		},
	};
</script>

<style></style>
